module.exports = __webpack_public_path__ + "img/0-114.6e6d3775.jpg";